import { useState } from "react";
import useAppState from "../../context/AppContext";
import { downloadUploadedDocument, getPropositionById, validateInvalidDocument } from "../../services/CustomerApiService";
import { AxiosError } from 'axios';
import { IApiErrors } from "../../context/model";
import UploadFilePreviewModal from "../../modals/common/UploadFilePreviewModal";
import { useNavigate } from "react-router-dom";
import { APP_URLS } from "../../const/AppConst";
import MgpMessage from "../../elements/MgpMessage/MgpMessage";
import LoaderModal from "../../modals/common/LoaderModal";
import { getFilename } from "../../utils/utils";
import MgpCardForm from "../../elements/MgpCardForm/MgpCardForm";
import StickButtonsBloc from "../../blocs/common/StickButtonsBloc";
import { isDoneProposition } from "../../utils/dataUtils";

type ListInvalidDocumentFormData = {
   
  }

  export default function ListInvalidDocumentFormComponent() {

    const {
      state: { proposition, jwtToken, showModal, signedDocument, isConseiller },
      dispatch,
    } = useAppState();

    const navigate = useNavigate();

    const [errorMsg, setErrorMsg] = useState<string | null>();
    const [loading, setLoading] = useState<boolean>(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [file, setFile] = useState<File | null>();
    const [invalidDocumentId, setInvalidDocumentId] = useState<string | null>();

    const onPreviewDocument = async (documentId: string, isInvalid: boolean) => {
        setLoading(true);
        try {
            const token = jwtToken!.accessToken;
            const res = await downloadUploadedDocument(token, proposition!.propositionId, documentId);
            const filename = getFilename(res.headers);
            const file = new File([res.data], filename);
            setFile(file)
            setModalIsOpen(true);
            setLoading(false);
            if (isInvalid) {
                setInvalidDocumentId(documentId);
            }
            dispatch({type: 'SHOW_MODAL', showModal: true});
        } catch (error) {
        setLoading(false);

        const err = error as AxiosError;
        console.log(err);
        if(err.response && err.response.status === 400) {
            const errorData = err.response?.data as IApiErrors;
            setErrorMsg("Erreur: " + errorData.message);
        } else {
            setErrorMsg("Une erreur technique est survenue ");
        }
        }
    }

    const handleDownloadDoc = async (documentId: string) => {
        setLoading(true);
        try {
        const token = jwtToken!.accessToken;
        const res = await downloadUploadedDocument(token, proposition!.propositionId, documentId);
        const filename = getFilename(res.headers);
        const file = new File([res.data], filename);

        if (file) {
            const a = document.createElement('a');
            a.download = file.name;
            a.href = window.URL.createObjectURL(file);
            a.click();
          }
      
        } catch (error) {
        setLoading(false);

        const err = error as AxiosError;
        console.log(err);
        if(err.response && err.response.status === 400) {
            const errorData = err.response?.data as IApiErrors;
            setErrorMsg("Erreur: " + errorData.message);
        } else {
            setErrorMsg("Une erreur technique est survenue ");
        }
        }
    }

    const handleReplace = (category: string, id: string, code: string) => {
        navigate({
            pathname: APP_URLS.uploadDocumentPage,
            search: `?id=${proposition!.propositionId}&documentCategory=${category}&documentId=${id}&documentTypeCode=${code}`,
        })
    }

    const onCloseModal = () => {
        setModalIsOpen(false);
        setInvalidDocumentId(null);
        dispatch({type: 'SHOW_MODAL', showModal: false});
    }

    const onNextAction = () => {
        const nextUrl = isConseiller?APP_URLS.infoModificationPage: APP_URLS.endPage;
        dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
        navigate({
            pathname: nextUrl,
            search: `?id=${proposition!.propositionId}`,
        });
    }

    const onPreviousAction = () => {
        if(isDoneProposition(proposition!)) {
            let hasSignature = proposition?.configuration?.hasSignature;

            if(hasSignature && signedDocument.length > 0) {
                dispatch({type: 'BACK_INFO_STEP', path: APP_URLS.infoSignatureStep2Page});
                navigate({
                    pathname: APP_URLS.infoSignatureStep2Page,
                    search: `?id=${proposition!.propositionId}`,
                });
            } else {
                dispatch({type: 'BACK_INFO_STEP', path: APP_URLS.recapPage});
                navigate({
                    pathname: APP_URLS.recapPage,
                    search: `?id=${proposition!.propositionId}`,
                });
            }
        }

    }

    const onValidateDocumentAction = async () => {
        setLoading(true);
        try {
            if (invalidDocumentId) {
                const token = jwtToken!.accessToken;
                await validateInvalidDocument(token, proposition!.propositionId, invalidDocumentId);
                const propositionPayload = await getPropositionById(token, proposition!.propositionId);
                dispatch({type: 'LOAD_PROPOSITION', proposition: propositionPayload.data});
                setLoading(false);
       
            } else {
                setLoading(false);
                setErrorMsg("Une erreur technique est survenue. Merci de réessayer");
            }
        } catch (error) {
            setLoading(false);

            const err = error as AxiosError;
            console.log(err);
            if(err.response && err.response.status === 400) {
                const errorData = err.response?.data as IApiErrors;
                setErrorMsg("Erreur: " + errorData.message);
            } else {
                setErrorMsg("Une erreur technique est survenue ");
            }
        }
    }

    const displayedDocuments = proposition?.documents.filter(doc => doc.documentCategory !== "contract" && doc.documentCategory !== "contract_letter");
  

    return(
        <form style={{width: '100%'}}>
            <div className='grid-flex jc-start m-y-lg'>
                {
                    displayedDocuments?.filter(doc => doc.status === "Invalide").map(doc => (
                        <MgpCardForm key={doc.documentId}
                            headerElement= {<p className="fw-bold fz-lg fushia">{doc.status}</p>}
                            name={doc.name}
                            onDownloadDoc={() => handleDownloadDoc(doc.documentId)}
                            onPreviewDoc={() => onPreviewDocument(doc.documentId, true)}
                            buttonName="Remplacer"
                            onClick={() => handleReplace(doc.documentCategory, doc.documentId, doc.documentTypeCode)}
                        />
                    ))
                }

                 {
                    displayedDocuments?.filter(doc => doc.status === "Reçu" || doc.status === 'Remis' ).map(doc => (
                        <MgpCardForm key={doc.documentId}
                            headerElement= {<p className="fw-bold fz-lg orange">{doc.status}</p>}
                            name={doc.name}
                            onDownloadDoc={() => handleDownloadDoc(doc.documentId)}
                            onPreviewDoc={() => onPreviewDocument(doc.documentId, true)}
                        />
                    ))
                }

                {
                    displayedDocuments?.filter(doc => doc.status === "Valide").map(doc => (
                        <MgpCardForm key={doc.documentId}
                            headerElement= {<p className="fw-bold fz-lg bleu">{doc.status}</p>}
                            name={doc.name}
                            onDownloadDoc={() => handleDownloadDoc(doc.documentId)}
                            onPreviewDoc={() => onPreviewDocument(doc.documentId, false)}
                        />
                    ))
                }
            
            </div>

            {modalIsOpen && file && <UploadFilePreviewModal file={file}  isOpen={modalIsOpen} onCloseModal={onCloseModal} showButton={invalidDocumentId && isConseiller ? true : false} buttonName="Valider" onUploadAction={onValidateDocumentAction}/>}
            
            <div>
                {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/>}
            </div>
            {loading && <LoaderModal hasMessage={false}/>}

            {!showModal && <StickButtonsBloc showNextButton={true} showPreviousButton={true} nextAction={onNextAction} previousAction={onPreviousAction} nextButtonName="Suivant"/>}
        </form>
    )
    }